import {RefCountableBase} from "@cm/utils"
import type {ThreeViewportTextureTileUpdaterMaterial} from "#three-texture-streaming/three-viewport-texture-tile-updater-material"
import {TRACE_TILED_TEXTURES} from "#three-texture-streaming/texture-tile-constants"
import {sceneLogger as logger} from "#three-texture-streaming/scene-logger"

const TRACE = TRACE_TILED_TEXTURES

export class ThreeViewportTextureTileUpdaterMaterialSet extends RefCountableBase {
    constructor(
        private tileUpdaterMaterials: ThreeViewportTextureTileUpdaterMaterial[],
        private disposeFn: () => void,
    ) {
        super({
            disposeFn: () => this.dispose(),
        })
        if (this.tileUpdaterMaterials.length === 0) {
            throw new Error("ThreeViewportTextureTileUpdaterMaterialSet: must have at least one material")
        }
    }

    dispose(): void {
        if (TRACE) {
            logger.log("ThreeViewportTextureTileUpdaterMaterialSet: Disposing")
        }
        this.tileUpdaterMaterials.forEach((material) => material.release())
        this.disposeFn()
    }

    updateFrameIndex(frameIndex: number): void {
        this.tileUpdaterMaterials.forEach((material) => material.updateFrameIndex(frameIndex))
    }

    get materials(): readonly ThreeViewportTextureTileUpdaterMaterial[] {
        return this.tileUpdaterMaterials
    }

    getRandomMaterial(): ThreeViewportTextureTileUpdaterMaterial {
        return this.tileUpdaterMaterials[Math.floor(Math.random() * this.tileUpdaterMaterials.length)]
    }
}
